export default "__VITE_ASSET__BGTUNVuI__"